import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_BLACK } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  padding: 32px;
  .top-wrap {
    display: flex;
    padding: 20px 0 16px 0;
    border-bottom: 1px solid ${rgba(COLOR_BLACK, 0.1)};
    &--half-wrap {
      width: 50%;
      display: flex;

      &__img-wrap {
        height: 56px;
        margin: auto 0;
      }
      &__text-wrap {
        padding-left: 24px;
        display: flex;
        flex-direction: column;
        small {
          padding-bottom: 5px;
        }
      }
    }
  }
  .bottom-wrap {
    display: flex;
    justify-content: space-between;
    &--quarter {
      padding-top: 16px;
      display: flex;
      flex-direction: column;
      span {
        padding-top: 4px;
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    padding: 16px;
    .top-wrap {
      display: flex;
      padding: 0 0;
      flex-wrap: wrap;
      border-bottom: none;
      &--half-wrap {
        padding: 16px 0;
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid ${rgba(COLOR_BLACK, 0.1)};
        &__img-wrap {
          height: 56px;
          min-width: 60px;
        }
      }
    }
    .bottom-wrap {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      &--quarter {
        width: 50%;
        padding-top: 16px;
        display: flex;
        flex-direction: column;
        span {
          padding-top: 4px;
        }
      }
    }
  }
`;
